<template>
</template>

<script>
import Vue from 'vue';

export default {
    data: function () {
        return {
            form: {
                vrm: this.vrm,
                product_type: false,
                bundle: false,
                affiliate: false,
            },
            products: this.productDetails,
            // These 'configs' are used to by the select-report-variant view
            bundleConfig: {
                history: true,
                finance: true,
                valuation: true,
            },
            singleConfig: {
                history: true,
                finance: true,
                valuation: true,
            },
            variantBundleType: 'full',
            variantSingleType: 'full',
            reportType: null,
            reportBundle: null,
            reportActive: null,
            selectedPrice: {},
        }
    },
    props: [
        'vrm',
        'productDetails',
    ],
    computed: {
        fullPrice: function () {
            return {
                price : this.products[0].price,
                bundle_total_price : this.products[1].price,
                bundle_price_per : this.products[1].price_per_unit
            }
        },
        historyPrice: function () {
            return {
                price : this.products[2].price,
                bundle_total_price : this.products[3].price,
                bundle_price_per : this.products[3].price_per_unit
            }
        },
        financePrice: function () {
            return {
                price : this.products[4].price,
                bundle_total_price : this.products[5].price,
                bundle_price_per : this.products[5].price_per_unit
            }
        },
        valuationPrice: function () {
            return {
                price : this.products[6].price,
                bundle_total_price : this.products[7].price,
                bundle_price_per : this.products[7].price_per_unit
            }
        },
        affiliateCode: function () {
            var url = window.location.href;
            var fragment = url.split('#')[1];
            return fragment;
        },
    },

    mounted() {
        this.setSelectedReport('full', true, 'fullBundle');
    },

    watch: {
        'bundleConfig.history': function (value) {
            if (!value && !this.bundleConfig.finance) {
                this.bundleConfig.finance = true;
            }
        },
        'bundleConfig.finance': function (value) {
            if (!value && !this.bundleConfig.history) {
                this.bundleConfig.history = true;
            }
        },
        'singleConfig.history': function (value) {
            if (!value && !this.singleConfig.finance) {
                this.singleConfig.finance = true;
            }
        },
        'singleConfig.finance': function (value) {
            if (!value && !this.singleConfig.history) {
                this.singleConfig.history = true;
            }
        },
        bundleConfig: {
            handler(checkboxes) {
                this.variantBundleType = this.getVariantProductType(checkboxes);
            },
            deep: true,
        },
        singleConfig: {
            handler(checkboxes) {
                this.variantSingleType = this.getVariantProductType(checkboxes);
            },
            deep: true,
        },
    },
    methods: {
        // unitPrice(type, bundle, singleKey = 'voucher_price') {
        //     let prices = this.getAllPrices(type);

        //     return bundle ? prices.bundle_price_per : prices[singleKey];
        // },

        // totalPrice(type, bundle) {
        //     let prices = this.getAllPrices(type);

        //     return bundle ? prices.bundle_total_price : prices.voucher_price;
        // },

        // getAllPrices(type) {
        //     let propertyName = type + 'Price';
        //     return this[propertyName];
        // },
        /**
         * In the select-product-variant view, product selection is handled
         * differently. The user picks their product by selecting checkboxes on
         * a bundle or a single product. If both history and finance are
         * checked, then we consider it a 'Full Check', otherwise it's a history
         * or finance check.
         *
         * @param      {object}  checkboxes
         * @return     {string}
         */
        getVariantProductType(checkboxes) {
            // If both checkboxes are ticked, then the variant product type
            // is 'full'
            if (checkboxes.history && checkboxes.finance) {
                return 'full';
            }

            // Otherwise if the history is checked it's a history check,
            // and the only other option is for it to be a finance check
            return checkboxes.history ? 'history' : 'finance';
        },

        /**
         * Update this.form with which product has been selected and use js to
         * submit the hidden form with a regular POST.
         *
         * NB the hidden form that's being submitted can be found at
         * public.free-car-check.partial.select-report-footer
         *
         * @param      {string}   productType
         * @param      {boolean}  bundle
         */
        chooseProductType(productType, bundle) {
            this.form.product_type = productType;
            this.form.bundle = bundle;

            Vue.nextTick().then(function () {
                document.getElementById('select-report-next-step').submit();
            }.bind(this));
        },

        round(value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        },

        setSelectedReport(reportType, reportBundle, reportActive) {
            this.reportType = reportType;
            this.reportBundle = reportBundle;
            this.reportActive = reportActive;

            if (reportType == 'finance') {
                this.selectedPrice = this.financePrice;
            }
            if (reportType == 'full') {
                this.selectedPrice = this.fullPrice;
            }
            if (reportType == 'history') {
                this.selectedPrice = this.historyPrice;
            }
            if (reportType == 'valuation') {
                this.selectedPrice = this.valuationPrice;
            }
        },
    },
    components: {
    }
}
</script>
